
import { createLogger } from 'redux-logger';

const logger = createLogger({
    collapsed: true,
    // predicate: (s, a) => a && a.type && (
    //   a.type.toLowerCase().includes("router")
    // )
    // predicate: (s, a) => a && a.type && !(
    //   a.type.toLowerCase().includes("ui/") ||
    //   a.type.toLowerCase().includes("bmapi")
    // ),
    // @ts-ignore
    // predicate: (s, a) =>
    //   a &&
    //   a.type &&
    //   (a.type.toLowerCase().includes("keycloak") ||
    //     a.type.toLowerCase().includes("state") ||
    //     a.type.toLowerCase().includes("authenticate") ||
    //     a.type.toLowerCase().includes("authorise") ||
    //     a.type.toLowerCase().includes("customer") ||
    //     a.type.toLowerCase().includes("persist") ||
    //     a.type.toLowerCase().includes("service") ||
    //     a.type.toLowerCase().includes("times") ||
    //     a.type.toLowerCase().includes("checkout") ||
    //     a.type.toLowerCase().includes("articles") ||
    //     a.type.toLowerCase().includes("promo") ||
    //     a.type.toLowerCase().includes("price") ||
    //     a.type.toLowerCase().includes("booking") ||
    //     a.type.toLowerCase().includes("router")
    //   ),
    // stateTransformer(state: ApplicationState) {

    //   // console.dir(window.location.href);
    //   // @ts-ignore
    //   return {
    //     articleIdsToShow: state.configuration?.data.articleIdsToShow,
    //     serviceIdsToShow: state.configuration?.data.serviceIdsToShow
    //   };
    // },
})

export default logger;
